import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Sun, Moon } from 'lucide-react';

interface ThemeModeSelectorProps {
  value: 'light' | 'dark';
  onChange: (mode: 'light' | 'dark') => void;
}

const ThemeModeSelector: React.FC<ThemeModeSelectorProps> = ({ value, onChange }) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">Theme Mode</Label>
      <p className="text-xs text-gray-600 mb-3">
        Choose the color theme for your ordering page
      </p>
      
      <RadioGroup
        value={value}
        onValueChange={(newValue) => onChange(newValue as 'light' | 'dark')}
        className="flex gap-4"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="dark" id="dark-mode" />
          <Label htmlFor="dark-mode" className="cursor-pointer flex items-center gap-2">
            <Moon className="h-4 w-4" />
            Dark Mode
          </Label>
        </div>
        
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="light" id="light-mode" />
          <Label htmlFor="light-mode" className="cursor-pointer flex items-center gap-2">
            <Sun className="h-4 w-4" />
            Light Mode
          </Label>
        </div>
      </RadioGroup>
      
      <p className="text-xs text-gray-500 mt-2">
        {value === 'light' 
          ? 'Light mode will adjust text colors for better visibility on light backgrounds'
          : 'Dark mode uses the default color scheme optimized for dark backgrounds'
        }
      </p>
    </div>
  );
};

export default ThemeModeSelector;